// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authorization-widget {
  margin-bottom: 40px;
}

.authorization-header {
  margin-bottom: 8px;
}

.authorization-title {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4em;
  color: rgba(0, 0, 0, 0.88);
  margin: 0;
}

.authorization-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.authorization-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

.authorization-checkbox-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.authorization-checkbox-wrapper .ant-checkbox-wrapper {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5714285714285714em;
  color: #5b8c00;
}

.authorization-checkbox-wrapper .ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {
  color: #5b8c00;
}

.authorization-checkbox-wrapper .ant-checkbox-wrapper-disabled .ant-checkbox-inner {
  background-color: #ffffff;
  border-color: #d9d9d9;
}

.authorization-tags {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.authorization-tag-default {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 1px 8px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6666666666666667em;
  color: rgba(0, 0, 0, 0.88);
  margin: 0;
}

.authorization-tag-required {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 1px 8px;
  background: #fff1f0;
  border: none;
  border-radius: 4px;
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6666666666666667em;
  color: #f5222d;
  margin: 0;
}

.authorization-description {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5714285714285714em;
  color: rgba(0, 0, 0, 0.88);
  margin: 0;
  align-self: stretch;
}

.authorization-scopes {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6666666666666667em;
  color: rgba(0, 0, 0, 0.65);
  margin-top: 8px;
}

.authorization-scopes-label {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/EndPointSection/components/AuthorizationWidget/AuthorizationWidget.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,SAAS;AACX;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":[".authorization-widget {\n  margin-bottom: 40px;\n}\n\n.authorization-header {\n  margin-bottom: 8px;\n}\n\n.authorization-title {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.4em;\n  color: rgba(0, 0, 0, 0.88);\n  margin: 0;\n}\n\n.authorization-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.authorization-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.authorization-checkbox-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.authorization-checkbox-wrapper .ant-checkbox-wrapper {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.5714285714285714em;\n  color: #5b8c00;\n}\n\n.authorization-checkbox-wrapper .ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {\n  color: #5b8c00;\n}\n\n.authorization-checkbox-wrapper .ant-checkbox-wrapper-disabled .ant-checkbox-inner {\n  background-color: #ffffff;\n  border-color: #d9d9d9;\n}\n\n.authorization-tags {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.authorization-tag-default {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 1px 8px;\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6666666666666667em;\n  color: rgba(0, 0, 0, 0.88);\n  margin: 0;\n}\n\n.authorization-tag-required {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 1px 8px;\n  background: #fff1f0;\n  border: none;\n  border-radius: 4px;\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6666666666666667em;\n  color: #f5222d;\n  margin: 0;\n}\n\n.authorization-description {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5714285714285714em;\n  color: rgba(0, 0, 0, 0.88);\n  margin: 0;\n  align-self: stretch;\n}\n\n.authorization-scopes {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6666666666666667em;\n  color: rgba(0, 0, 0, 0.65);\n  margin-top: 8px;\n}\n\n.authorization-scopes-label {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.88);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
